import { render, staticRenderFns } from "./index.vue?vue&type=template&id=adde9848&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/buy-now/buy-now.scss?vue&type=style&index=0&id=adde9848&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adde9848",
  null
  
)

export default component.exports